export const enum eAccountRouteNames {
  Account = 'RocketAccount::Menu:Account',
  Login = 'RocketAccount::Login',
  Register = 'RocketAccount::Register',
  ManageProfile = 'RocketAccount::ManageYourProfile',
}
